/* @ngInject */
const optionsHandler = () => {
  const self = {}

  self.setDefaults = (options = {}, defaults) => {
    return Object.assign({}, defaults, options)
  }

  return self
}
export default optionsHandler



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/optionsHandler.js